import { motion } from 'framer-motion'

// Components
import Tabs from 'components/interestform/slides/licensepricing/tabs'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './licensepricing.css'

const data = [
  {
    title: 'Category C',
    fee: '$37.50',
    sec2: '1.5% (of 2%)',
    sec15: '7.5% (of 10%)',
    sec60: '15% (of 20%)',
  },
  {
    title: 'Category B',
    fee: '$375',
    sec2: '3.75% (of 5%)',
    sec15: '11.25% (of 15%)',
    sec60: '18.75% (of 25%)',
  },
  {
    title: 'Category A',
    fee: '$1125',
    sec2: '7.5% (of 10%)',
    sec15: '18.75% (of 25%)',
    sec60: '26.25% (of 35%)',
  },
  {
    title: 'Buy Down',
    fee: 'TBD',
    sec2: 'TBD',
    sec15: 'TBD',
    sec60: 'TBD',
  },
]

const LicensePricing = (): JSX.Element => {
  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={commonStyles.heading}>Three categories of original music</h1>
      <div className={commonStyles.textContent}>
        <div className={commonStyles.subheading}>
          When a new track using a sample is released, generated revenue from both the master rights and publishing rights of the new song
          is shared with the original rightsholders
        </div>
        <div className={commonStyles.paragraph}>
          For example, a 14 second category B sample gives 11.25% of new master revenue to the original recording rightsholders, and 15%
          publishing ownership to the original publishing rightsholders!
        </div>
        <div className={commonStyles.paragraph}>
          Licensees will also have the option to pay a higher upfront fee for the license in order to lower the master royalty. The
          publishing copyright share will still remain the same. Tracklib will notify you once the specifics around this option are
          finalized
        </div>
        <div className={commonStyles.paragraph}>Below is a breakdown of the revenue that rightsholders will earn from being licensed</div>
      </div>
      <div className={styles.tableWrapper}>
        <table>
          <tbody>
            <tr>
              <th>CATEGORY</th>
              <th>LICENSE FEE</th>
              <th>&lt; 2 seconds</th>
              <th>&lt; 15 seconds</th>
              <th>&lt; 60 seconds</th>
            </tr>
            {data.map(cat => {
              return (
                <tr key={cat.title}>
                  <th>{cat.title}</th>
                  <td>{cat.fee}</td>
                  <td>{cat.sec2}</td>
                  <td>{cat.sec15}</td>
                  <td>{cat.sec60}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <div className={styles.tabsWrapper}>
        <Tabs data={data} />
      </div>
    </motion.div>
  )
}

export default LicensePricing
